import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { formatDateOnlyForStorage } from '../../../Helpers/DateUtils';

interface ProjectEndDateModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: (endDate: string) => Promise<void>;
    submitting?: boolean;
    error?: string | null;
}

export const ProjectEndDateModal: React.FC<ProjectEndDateModalProps> = ({
    show,
    onHide,
    onConfirm,
    submitting = false,
    error = null,
}) => {
    const [endDate, setEndDate] = useState('');

    // Set default date when modal opens
    useEffect(() => {
        if (show) {
            setEndDate(formatDateOnlyForStorage(new Date()));
        }
    }, [show]);

    const handleConfirm = async () => {
        if (!endDate) return;
        await onConfirm(endDate);
    };

    const handleClose = () => {
        setEndDate('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Välj slutdatum</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                    </Alert>
                )}
                <Form.Group>
                    <Form.Label>Slutdatum för projektet</Form.Label>
                    <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        disabled={submitting}
                        autoFocus
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={submitting}>
                    Avbryt
                </Button>
                <Button
                    variant="primary"
                    onClick={handleConfirm}
                    disabled={submitting || !endDate}
                >
                    Bekräfta
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
